export default __webpack_public_path__ + "static/gs-f376c1b7211fceba923c107714c61a80.svg";